import BaseComponent from "../BaseComponent";
import Button from "../Button";
import { IntentDropdown } from "../IntentDropdown";

export default class LocalIntentSubCon extends BaseComponent {
    /**
     * Submenu view for input node that references intents handled locally
     * @module LocalIntentSubCon
     * @param {Object} props React props
     */
    constructor(props) {
        super(props);
        // Data model
        this.varModel = (this.props.data && this.props.data.intent) ? this.props.data.intent : this.initVarModel();
        // List index for this item
        this.varIdx = (this.props.data && this.props.data.varIdx) ? this.props.data.varIdx : 0;
    }

    /**
     * Initialize dummy data model
     * @returns {string}
     */
    initVarModel() {
        return "";
    }

    /**
     * Set config proxy; catches own input value updates and update its data model before saving to list
     * @param {string} key
     * @param {string} value
     */
    setConfig(key, value) {
        this.varModel = value;
    }
    intentOptions() {
        var options = window.apm.knowledgeBase.getUniqueIntents();
        if (!this.props.context.props || !this.props.context.props.context) {
            return options;
        }
        if (this.props.context.props.context.props.config.localIntents !== undefined && this.props.context.props.context.props.config.localIntents.length > 0) {
            this.props.context.props.context.props.config.localIntents.forEach(li => {
                var intentIndex = options.findIndex(intents => intents.value === li);
                if (intentIndex !== -1) options.splice(intentIndex, 1);
                return options;
            });

        }
      if(this.props.context.props&&this.props.context.props.valKey!=="localIntents") { var currentIndex = options.findIndex(ele => ele.value === this.props.context.props.context.id);
        options.splice(currentIndex, 1);}
        if (this.props.context.props.context.props.config.parentIntent) {
            var parentIndex = options.findIndex(ele => ele.value === this.props.context.props.context.props.config.parentIntent);
            if (parentIndex !== -1) options.splice(parentIndex, 1);
        }
        if (this.props.context.props.context.props.config.childIntents !== undefined && this.props.context.props.context.props.config.childIntents.length > 0) {
            this.props.context.props.context.props.config.childIntents.forEach(li => {
                var intentIndex = options.findIndex(intents => intents.value === li);
                if (intentIndex !== -1) options.splice(intentIndex, 1);
            });
            window.apm.serialized.components.intents.forEach(op => {
                if (op.props.isGlobalIntent) {
                    var globlIntentIndex = options.findIndex(opt => opt.id === op.id);
                    options.splice(globlIntentIndex, 1);
                }
            });
        }
       if(this.props.context.props.valKey!=="localIntents"){ window.apm.serialized.components.intents.forEach(i => {
            if (i.props.config.parentIntent) {
                var parentIntentIndex = options.findIndex(ele => ele.value === i.id);
                if (parentIntentIndex !== -1) options.splice(parentIntentIndex, 1);
            }
        });}
        return options;

    }
    /**
     * React render
     * @returns {XML}
     */
    render() {
        // Get current selection
        const preSelection = window.apm.knowledgeBase.getIntentIndexFromValue(this.varModel);

        return (
            <div>
                {<IntentDropdown wide={true} optionName={this.getPropLabel("select_intent")}
                    options={this.intentOptions()}
                    context={this} valKey={"selection"} selection={preSelection} />}
                {(() => {
                    var items = this.props.context.state ? JSON.stringify(this.props.context.state.items) : [];
                    if (this.varModel && items.includes(this.varModel)) {
                        // Display edit & delete button for editing
                        return (
                            <table style={{ width: "100%" }}><tbody><tr>
                                <td style={{ paddingRight: "2px" }}>
                                    {!this.props.readOnly && <Button icon={"icon-trash"} tint={"warning"} disable={true}
                                        callback={() => {
                                            this.props.context.remove(this.varIdx);
                                            this.varModel = this.initVarModel();
                                            this.props.domContext.removeSubmenu();
                                        }}
                                    />}
                                </td>
                                <td>
                                    {<Button label={this.getPropLabel("save")} wide={true}
                                        callback={() => {
                                            this.props.context.update(this.varModel, this.varIdx);
                                            this.varModel = this.initVarModel();
                                            this.props.domContext.removeSubmenu();
                                        }}
                                    />}
                                </td>
                            </tr></tbody></table>
                        );
                    }

                    return (
                        <Button label={this.getPropLabel("add")} wide={true}
                            callback={() => {
                                if (this.varModel) {
                                    // Add current data model to item list
                                    this.props.context.add(this.varModel);
                                }
                                this.varModel = this.initVarModel();
                                this.props.domContext.removeSubmenu();
                            }}
                        />
                    );
                })()}
            </div>
        );
    }
}